const globalScripts = () => {};

export { globalScripts as g };

//# sourceMappingURL=app-globals-0f993ce5.js.map